// @ts-nocheck
/* eslint-enable */
import { useState } from 'react';
import { DEFAULT } from 'app/shared/models/Filter';
import isEqual from 'lodash/isEqual';

// Icons
import IconPayments from 'images/icons/payments.min.svg';
import IconBed from 'images/icons/bed.min.svg';

const INFO_CARD_MAP = {
  price: {
    title: 'Name your price',
    description: 'Set your price range to only see the homes that fit your budget.',
    icon: IconPayments,
  },
  bedrooms: {
    title: 'Need more room?',
    description: 'Filter homes by the number of bedrooms you need.',
    icon: IconBed,
  },
};

export const useInfoCards = () => {
  const [shouldDisplayPriceSlider, setShouldDisplayPriceSlider] = useState(false);
  const [shouldDisplayBedSelector, setShouldDisplayBedSelector] = useState(false);
  const [infoCardDetails, setInfoCardDetails] = useState(null);

  const getInfoCardType = ({ priceState, bedState }) => {
    if (priceState.max === DEFAULT.price.max && priceState.min === DEFAULT.price.min) {
      setShouldDisplayPriceSlider(true);
      setInfoCardDetails(INFO_CARD_MAP.price);
      return;
    } else if (isEqual(bedState, DEFAULT.bedrooms)) {
      setShouldDisplayBedSelector(true);
      setInfoCardDetails(INFO_CARD_MAP.bedrooms);
      return;
    } else {
      setShouldDisplayPriceSlider(false);
      setShouldDisplayBedSelector(false);
      setInfoCardDetails(null);
      return;
    }
  };

  return [getInfoCardType, infoCardDetails, shouldDisplayPriceSlider, shouldDisplayBedSelector];
};
